import { render, staticRenderFns } from "./WordMoreMobile.vue?vue&type=template&id=58674d5c&scoped=true&"
import script from "./WordMoreMobile.vue?vue&type=script&lang=js&"
export * from "./WordMoreMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58674d5c",
  null
  
)

export default component.exports